import { mount } from "@vue/test-utils";
import TwitterImage from "@/components/core/TwitterImage";

describe("TwitterImage test", () => {
  let wrapper;

  beforeEach(() => {
    wrapper = mount(TwitterImage);
  });

  it("Match con el snapshot", async () => {
    expect(wrapper.html()).toMatchSnapshot();
  });

  it("Render del component TwitterImage", () => {
    expect(wrapper).toBeDefined();
  });
});
